import * as React from "react";
import {
  Columns,
  Column,
  Stack,
  Section,
  Heading,
} from "@origin-digital/ods-core";
import { HSNextBestAction } from "./HSNextBestAction";

export interface IOfferContent {
  experienceId: string;
  [key: string]: any;
}

export interface ISecondaryPlacement {
  offers: IOfferContent[];
}

export const SecondaryPlacement = ({ offers }: ISecondaryPlacement) => {
  if (offers.length === 0) {
    return null;
  }

  const displayable = offers.slice(0, 2);

  return (
    <Section backgroundColor="grey50">
      <Stack space="xlarge" data-id="secondary-placement">
        <Heading variant="h3">You may be interested in</Heading>
        <Columns collapseBelow="lg" space="xlarge">
          {displayable.map((displayableContent) => (
            <Column
              width="1/2"
              key={displayableContent.experienceId}
              data-id="secondary-placement-column"
            >
              <HSNextBestAction content={displayableContent as any} />
            </Column>
          ))}
        </Columns>
      </Stack>
    </Section>
  );
};
